import { useCallback, useMemo } from 'react';
import {
	ToothPathologyToothWear,
	ToothPathologyToothWearAbrasion,
} from '../../../../../graphql/graphql';

interface Props {
	toothWear?: ToothPathologyToothWear;
	setToothWear: (toothWear: ToothPathologyToothWear) => void;
}

export default function useToothPathologyToothWearAbrasion({
	toothWear,
	setToothWear,
}: Props) {
	const setAbrasion = useCallback(
		(abrasion: ToothPathologyToothWearAbrasion) => {
			setToothWear({
				...toothWear,
				abrasion,
			});
		},
		[toothWear, setToothWear],
	);

	return useMemo(
		() => ({
			abrasion: {
				zones: toothWear?.abrasion?.zones ?? [],
				setAbrasion,
			},
		}),
		[toothWear],
	);
}
